import { h, Component } from 'preact';
import HTML from 'components/core/html/html';
import { joinClasses } from "utils/utils.js";
import { submitMailchimpSignUpForm } from 'helpers';
import { newsletter, close } from 'components/shared/svgIcons/icons';
import Store from 'store/store';
import s from 'components/shared/subscribe/subscribe.sss';

const localKey = '6Lc0kbAeAAAAAPvXhj1J_SCrdawwmp1UL44YRPLT';
const prodKey = '6LcHMLMeAAAAAGmtAQ0oPDTGK7Pte8N9bhXUcROI';

export default class Subscribe extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showFormSuccess: false,
			formError: false,
			lastFormStatus: null,
			promptBannerFirstHide: true
		};
		this.copy = {
			bannerText: 'Product, creative & tech news direct to your inbox',
			heading: 'One email, lots of insight.',
			subheading: 'Sign up to receive our newsletter direct to your inbox',
			namePlaceholder: 'Full name*',
			emailPlaceholder: 'Email address*',
			terms: 'By checking this box you confirm that you are over 18 years of age, have read & agree to our [Privacy Policy*](+../privacy/)',
			alreadySubscribedError: 'This email is already subscribed',
			invalidEmailError: 'Please use a valid email address',
			genericFormError: 'Unable to submit form',
			captchaError: 'Please confirm that you are human'
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.successAction = this.successAction.bind(this);
		this.errorAction = this.errorAction.bind(this);
		this.renderCaptcha = this.renderCaptcha.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		document.body.style.overflow = nextProps.formOpen ? 'hidden' : '';
	}

	componentDidMount() {
		if (window.grecaptcha && window.grecaptcha.render) {
			this.renderCaptcha();
		} else {
			Store.on('CAPTCHA_LOADED', this.renderCaptcha);
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.promptVisible !== this.props.promptVisible) {
			if (this.state.promptBannerFirstHide) {
				this.setState({
					promptBannerFirstHide: false
				});
			}
		}
	}

	renderCaptcha() {
		const widgetName = `signup${this.props.isPrompt ? 'Prompt' : ''}WidgetId`;
		const widgetId = `signup-captcha${this.props.isPrompt ? '-prompt' : ''}`;
		if (window[widgetName]) {
			return;
		}
		window[widgetName] = window.grecaptcha.render(widgetId, {
			'sitekey' : __IS_LOCAL__ ? localKey : prodKey
		});
	}

	handleSubmit(e) {
		e.preventDefault();
		const formData = new FormData(this.form);
		let data = {
			SOURCE: 'subscribeform'
		};
		formData.forEach((value, key) => data[key] = value);
		data['group[84222][2]'] = true;
		const widgetName = `signup${this.props.isPrompt ? 'Prompt' : ''}WidgetId`;

		submitMailchimpSignUpForm({
			data,
			successAction: this.successAction,
			errorAction: this.errorAction,
			widget: widgetName
		});
	}

	successAction() {
		this.form.reset();
		this.props.hideSubscribePrompt('subscribed');
		const { formOpen, toggleForm } = this.props;
		this.setState({
			showFormSuccess: true,
			lastFormStatus: 'successStatus'
		});
		setTimeout(() => {
			if (formOpen) toggleForm();
			this.setState({
				showFormSuccess: false
			});
		}, 3000);
	}

	errorAction(errMessage) {
		if (errMessage.match(/already subscribed to list/)) {
			this.setState({
				formError: this.copy.alreadySubscribedError
			});
		} else if (errMessage.match(/email address must contain/)) {
			this.setState({
				formError: this.copy.invalidEmailError
			});
		} else if (errMessage.match(/captcha/)) {
			this.setState({
				formError: this.copy.captchaError
			});
		} else {
			this.setState({
				formError: this.copy.genericFormError
			});
		}
		this.setState({
			lastFormStatus: 'errorStatus'
		});
		setTimeout(() => {
			this.setState({
				formError: false
			});
		}, 3000);
	}

	renderForm(open) {
		const { formError, showFormSuccess, lastFormStatus } = this.state;
		return(
			<div class={s.overlay}>
				<div class={joinClasses(s.fade, open && s.visible)} onClick={this.props.toggleForm} />
				<div class={joinClasses(s.formContainer, open && s.formOpen)}>
					<div class={s.formCloseIcon} onClick={this.props.toggleForm}>
						{close}
					</div>
					<div class={s.formContent}>
						<h2 class={s.formHeading}>{this.copy.heading}</h2>
						<span class={s.formSubheading}>{this.copy.subheading}</span>
						<form
							class={s.form}
							id="mc-embedded-subscribe-form"
							ref={ref => this.form = ref}
							onSubmit={this.handleSubmit}
						>
							<input
								class={s.textInput}
								type="text"
								name="NAME"
								placeholder={this.copy.namePlaceholder}
								key="NAME"
								required
							/>
							<input
								class={s.textInput}
								type="TEXT"
								name="EMAIL"
								placeholder={this.copy.emailPlaceholder}
								key="EMAIL"
								required
							/>
							<div class={s.legalsSubmission}>
								<input
									type="checkbox"
									id="terms"
									name="group[83902][1]"
									value="true"
									required
								/>
								<label for="terms">
									<HTML class={joinClasses('small')} content={this.copy.terms} markdown />
								</label>
							</div>
							<div id={`signup-captcha${this.props.isPrompt ? '-prompt' : ''}`} class={joinClasses('g-recaptcha', s.captcha)} />
							<span class={s.errorMessage}>{formError && formError}</span>
							<button class={joinClasses(s.formSubmitButton, )} type="submit" value="Submit">
								Subscribe
								<div class={joinClasses(s.btnInfo, formError && s.formError, showFormSuccess && s.formSuccess, lastFormStatus && s[lastFormStatus])}/>
							</button>
							<div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
								<input type="text" name="b_a832f48f937a864af2e7f539c_3cca162333" tabindex="-1" value="" />
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	}

	render({ isPrompt, formOpen, toggleForm, promptVisible, hideSubscribePrompt }) {
		const { promptBannerFirstHide } = this.state;
		return (
			<div class={s.container}>
				<div class={joinClasses(
					s.banner,
					isPrompt && s.promptBanner,
					formOpen && s.fadeAway,
					promptVisible && s.promptVisible,
					promptBannerFirstHide && s.firstHide)}
				>
					{isPrompt && (
						<div class={s.close} onClick={hideSubscribePrompt}>
							{close}
						</div>
					)}
					<div class={s.content}>
						<div class={s.newsletterIcon}>{newsletter}</div>
						<p>
							{this.copy.bannerText}
							<span onClick={toggleForm}>Subscribe</span>
						</p>
					</div>
				</div>
				{this.renderForm(formOpen)}
			</div>
		);
	}
}
